export enum ProjectStatus {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
}